import React from "react";
import "./FollowUpNotes.css";

const FollowUpNotes = () => {
  return (
    <div className="followup-box">
      <h3 className="followup-title">Follow-Up Notes</h3>

      <div className="followup-section">
        <h4>How to Find the Recruiter</h4>
        <ul>
          <li>Check the job posting → scroll to “Posted by”.</li>
          <li>Search LinkedIn: “Recruiter + Company + Location”.</li>
          <li>Look at company employees → filter by HR, Talent, Recruiter.</li>
          <li>Search Google: “Company name + HR email”.</li>
          <li>If no recruiter: contact team lead from LinkedIn.</li>
        </ul>
      </div>

      <div className="followup-section">
        <h4>Short Follow-Up Message (copy & paste)</h4>
        <div className="followup-snippet">
            Application for [] Role – Yousif Almusawi

            <br></br><br></br><br></br>
            Hi,<br></br><br></br>
            I hope you're doing well. I’m reaching out because I recently applied for the [] position and wanted to introduce myself directly. I have strong experience building end-to-end analytics systems using Python, SQL, ETL automation, and Power BI/Tableau. My work has improved reporting speed, revenue visibility, and forecasting accuracy for multi-location operations.
<br></br><br></br>
            I’m confident I can bring the same impact to your team.
            If you’re open to a quick conversation, I’d appreciate the chance to discuss how my background aligns with your needs.
<br></br><br></br>
            Thank you for your time,<br></br>
            Yousif Almusawi
        </div>
      </div>

      <div className="followup-section">
        <h4>Best Timing</h4>
        <ul>
          <li>1–2 days after application → soft follow-up.</li>
          <li>3–5 days later → stronger follow-up.</li>
          <li>After interview → follow-up within 24 hours.</li>
          <li>Ghosted over 10 days → final follow-up.</li>
        </ul>
      </div>

      <div className="followup-section">
        <h4>How Often to Follow Up</h4>
        <ul>
          <li>Don’t message every day → looks desperate.</li>
          <li>Every 4–6 days is acceptable.</li>
          <li>After 3 follow-ups → move on but keep job active.</li>
        </ul>
      </div>

      <div className="followup-section">
        <h4>Good Signs (Green Flags)</h4>
        <ul>
          <li>Recruiter views your profile.</li>
          <li>They reply with “Thank you for your interest”.</li>
          <li>They accept your connection request.</li>
        </ul>
      </div>

      <div className="followup-section">
        <h4>Bad Signs (Red Flags)</h4>
        <ul>
          <li>No reply after 3 messages.</li>
          <li>Job disappears from LinkedIn.</li>
          <li>Hiring manager viewed your profile but no updates.</li>
        </ul>
      </div>
    </div>
  );
};

export default FollowUpNotes;
